import { useEffect, useState } from "react";
import { Card, Col, Container, Row, Button, Image } from "react-bootstrap";
import { useParams } from "react-router";
import StepOne from "../components/autoagendamiento/StepOne";
import { withTranslation } from "react-i18next";
import StepTwo from "../components/autoagendamiento/StepTwo";
import Get from "../api/Get";
import {
  ACCOUNT_CONF_MESSAGES_GET_BY_ID,
  ACCOUNT_SETTING_GET_BY_ID,
  BASE_URL_WS,
  GET_LINK_PATIENT_AUTOAGENDAMIENTO,
  SAVE_LINK_PATIENT_AUTOAGENDAMIENTO,
} from "../api/Routes";
import LoadingList from "../loader/LoadingList";
import moment from "moment";
import StepTree from "../components/autoagendamiento/StepTree";
import CountdownComponentSimple from "../components/CountdownComponentSimple";
import Post from "../api/Post";
import StepOneCLB from "../components/autoagendamiento/StepOneCLB";
import StepTreeCLB from "../components/autoagendamiento/StepTreeCLB";
import { isBase64 } from "../utils/isBase64";
import StepTwoAutoagendamientoMexico from "../components/autoagendamiento/StepTwoAutoagendamientoMexico";
import ComponentModalErrorSever from "../components/ComponentModalErrorSever";
import { convertSource } from "../utils/convertSource";
import { getTokenExternal } from "../utils/getTokenExternal";
import SockJsClient from "react-stomp";
import { AutagendamientoStyles } from "../theme/AutagendamientoStyles";
import DeclinadoLegalWarning from "../components/conferencepublic/DeclinadoLegalWarning";

function Autoagendamiento({ t, i18n }) {
  const { id } = useParams();
  const idPatient = id;
  const [loading, setLoading] = useState(true);
  const [validLink, setValidLink] = useState(true);
  const [startMeeting, setStartMeeting] = useState(null);
  const [currentTime, setCurrentTime] = useState(null);
  const [clientTime, setClientTime] = useState(Date.now());
  const [reservadoExitosamente, setReservadoExitosamente] = useState(false);
  const [isPedienteAprobacion, setIsPendienteAprobacion] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [phoneNumber2, setPhoneNumber2] = useState(null);
  const [tipoSangre, setTipoSangre] = useState("");
  const [companyType, setCompanyType] = useState(null);
  const [paciente, setPaciente] = useState(null);
  const [notEdit, setNotEdit] = useState(false);
  const [fieldSettings, setFieldSettings] = useState([]);
  const [declined, setDeclined] = useState(false);

  //para saber el sourcce
  const [source, setSource] = useState("autoagendamientocat");

  //configuration account
  const [configuration, setConfiguration] = useState(null);

  //server error
  const [showModalError, setShowModalError] = useState(false);
  const [errorServer, setErrorServer] = useState(null);
  const handleClose = () => setShowModalError(false);

  //payment
  const [payment, setPayment] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState("currentflow");

  const initColombusA = {
    id: "",
    roadType: "",
    streetField1: "",
    streetField2: "",
    streetField3: "",
    propertyNumber: "",
    propertyType: "",
    propertyTypeAdditional: "",
    unitNumber: "",
  };
  const initEps = {
    id: "",
    nombreEps: "",
    codigo: "",
  };

  const [initialData, setInitialData] = useState({
    id: "",
    name: "",
    middleName: "",
    seccondSurname: "",
    lastName: "",
    curp: "",
    gender: "",
    dateOfBirthday: "",
    nationality: "",
    externalId: "",
    phoneNumber: "",
    phoneNumber2: "",
    email: "",
    bloodType: "",
    occupation: "",
    address: "",
    peso: "",
    talla: "",
    sintomas: "",
    dayAppointment: "",
    doctorId: "",
    hourDayId: "",
    hourDayHour: "",
    doctorName: "",
    especialidadName: "",
    especialidadId: "",
    account: "",
    currentInsurance: "",
    aceptarTerminos: true,
    linkPatient: isBase64(id) ? atob(id) : null,
    location: "",
    neighborhood: "",
    identityDocumentType: "",
    documentNumber: "",
    choiceType: "",
    expediente: "",
    patientRelationship: "",
    hourInit: "",
    colombusAddress: initColombusA,
    countryBirth: "",
    eps: initEps,
    tipoPlan: "",
    titular: {
      documentNumber: "",
      identityDocumentType: {
        id: "",
      },
    },
  });

  const [currentStep, setCurrentStep] = useState(0);

  const handleNextStep = (newData, final = false) => {
    setInitialData((prev) => ({ ...prev, ...newData }));
    if (final) {
      makeRequest(newData);
      return;
    }
    setCurrentStep((prev) => prev + 1);
  };
  const handlePrevStep = (newData) => {
    setInitialData((prev) => ({ ...prev, ...newData }));
    setCurrentStep((prev) => prev - 1);
  };

  useEffect(() => {
    async function getFields() {
      try {
        const tokenObj = await getTokenExternal(
          initialData.company
            ? initialData.company
            : initialData.account.partner.company
        );
        console.log(tokenObj);
        if (tokenObj.status === 200) {
          const { access_token } = tokenObj.data;
          const response = await Get({
            url: `${ACCOUNT_SETTING_GET_BY_ID}/${initialData.account.id}`,
            access_token: access_token,
          });
          if (response.data.state) {
            setFieldSettings(response.data?.data?.formSettingsDTOList || []);
          }

          const responseConf = await Get({
            url: `${ACCOUNT_CONF_MESSAGES_GET_BY_ID}/${initialData.account.id}`,
            access_token: access_token,
          });
          if (responseConf.data.state) {
            setConfiguration({
              approvedServiceText:
                responseConf.data.data?.approvedServiceText || "",
              informationPatientStep1:
                responseConf.data.data?.informationPatientStep1 || "",
              informationTelemedicine:
                responseConf.data.data?.informationTelemedicine || "",
              informedConsent: responseConf.data.data?.informedConsent || "",
              urlImage: responseConf.data.data?.urlImage || "",
              colorFont: responseConf.data.data?.colorFont || "",
              fontSize: responseConf.data.data?.fontSize || "",
              paymentText: responseConf.data.data?.paymentText || "",
            });
          }
        }
      } catch (error) {}
    }
    getFields();
  }, [initialData]);
  console.log(source);
  const steps = [
    companyType === "colombia" ? (
      <StepOneCLB
        next={handleNextStep}
        initialData={initialData}
        notEdit={notEdit}
        phoneNumber={phoneNumber}
        tipoSangre={tipoSangre}
        paciente={paciente}
        setPhoneNumber={setPhoneNumber}
        setTipoSangre={setTipoSangre}
        setInitialData={setInitialData}
        setShowModalError={setShowModalError}
        setErrorServer={setErrorServer}
        source={source}
        phoneNumber2={phoneNumber2}
        setPhoneNumber2={setPhoneNumber2}
        fieldSettings={fieldSettings}
        configuration={configuration}
      />
    ) : (
      <StepOne
        next={handleNextStep}
        initialData={initialData}
        phoneNumber={phoneNumber}
        tipoSangre={tipoSangre}
        phoneNumber2={phoneNumber2}
        setPhoneNumber2={setPhoneNumber2}
        setPhoneNumber={setPhoneNumber}
        setTipoSangre={setTipoSangre}
        account={initialData.account}
      />
    ),
    companyType === "colombia" ? (
      <StepTwo
        next={handleNextStep}
        setInitialData={setInitialData}
        initialData={initialData}
        prev={handlePrevStep}
        setShowModalError={setShowModalError}
        setErrorServer={setErrorServer}
      />
    ) : (
      <StepTwoAutoagendamientoMexico
        next={handleNextStep}
        setInitialData={setInitialData}
        initialData={initialData}
        prev={handlePrevStep}
        speciality={null}
        linkAllianz={true}
      />
    ),
    companyType === "colombia" ? (
      <StepTreeCLB
        next={handleNextStep}
        initialData={initialData}
        isPedienteAprobacion={isPedienteAprobacion}
        setValidLink={setValidLink}
        prev={handlePrevStep}
        setReservadoExitosamente={setReservadoExitosamente}
        reservadoExitosamente={reservadoExitosamente}
        companyType={companyType}
        source={source}
        setShowModalError={setShowModalError}
        setErrorServer={setErrorServer}
        setPayment={setPayment}
        setPaymentStatus={setPaymentStatus}
        configuration={configuration}
        setDeclined={setDeclined}
      />
    ) : (
      <StepTree
        next={handleNextStep}
        initialData={initialData}
        isPedienteAprobacion={isPedienteAprobacion}
        setValidLink={setValidLink}
        prev={handlePrevStep}
        setReservadoExitosamente={setReservadoExitosamente}
        reservadoExitosamente={reservadoExitosamente}
        companyType={companyType}
        source={source}
        setPayment={setPayment}
        setPaymentStatus={setPaymentStatus}
        configuration={configuration}
      />
    ),
  ];

  const makeRequest = (formdata) => {
    //console.log('formSubmit '+ formdata)
  };

  const validateLink = (active, currentTimeServer, mDuration, dateCreated) => {
    if (!active) {
      setValidLink(false);
    }

    let currentTS = moment(currentTimeServer, "DD/MM/YYYY HH:mm:ss");
    let fechaValidez = moment(dateCreated, "DD/MM/YYYY HH:mm").add(
      mDuration,
      "minutes"
    );

    setCurrentTime(currentTS.toDate().getTime());
    setStartMeeting(fechaValidez);

    if (currentTS.isAfter(fechaValidez)) {
      //console.log('after')
      setValidLink(false);
    }
  };

  const onComplete = () => {
    setValidLink(false);
    let d = {
      id: atob(id),
      active: false,
    };
    Post({
      url: SAVE_LINK_PATIENT_AUTOAGENDAMIENTO,
      data: d,
      header: false,
    }).then((response) => {
      //console.log(response)
    });
  };

  useEffect(() => {
    setLoading(true);
    Get({
      url: `${GET_LINK_PATIENT_AUTOAGENDAMIENTO}/${idPatient}`,
      noToken: true,
    })
      .then((response) => {
        let data = response.data.data;
        //console.log(data)
        setPaciente(data.patient);
        let colombusA = initColombusA;
        if (data.patient.colombusAddress) {
          colombusA.id = data.patient.colombusAddress.id;
          colombusA.roadType = data.patient.colombusAddress.roadType
            ? data.patient.colombusAddress.roadType.id
            : null;
          colombusA.streetField1 = data.patient.colombusAddress.streetField1;
          colombusA.streetField2 = data.patient.colombusAddress.streetField2;
          colombusA.streetField3 = data.patient.colombusAddress.streetField3;
          colombusA.propertyNumber =
            data.patient.colombusAddress.propertyNumber;
          colombusA.propertyType = data.patient.colombusAddress.propertyType
            ? data.patient.colombusAddress.propertyType.id
            : null;
          colombusA.propertyTypeAdditional = data.patient.colombusAddress
            .propertyTypeAdditional
            ? data.patient.colombusAddress.propertyTypeAdditional.id
            : null;
          colombusA.unitNumber = data.patient.colombusAddress.unitNumber;
        }
        let epsObj = initEps;
        if (data.patient.eps) {
          epsObj.id = data.patient.eps.id;
          epsObj.nombreEps = data.patient.eps.nombreEps;
          epsObj.codigo = data.patient.eps.codigo;
        }
        let entity = {
          id: data.patient.id,
          name: data.patient.name.toUpperCase(),
          middleName: data.patient.middleName
            ? data.patient.middleName.toUpperCase()
            : "",
          seccondSurname: data.patient.seccondSurname
            ? data.patient.seccondSurname.toUpperCase()
            : "",
          lastName: data.patient.lastName.toUpperCase(),
          gender: data.patient.gender,
          dateOfBirthday: data.patient.dateOfBirthday
            ? new Date(moment(data.patient.dateOfBirthday, "DD-MM-YYYY"))
            : "",
          nationality: data.patient.nationality ? data.patient.nationality : "",
          phoneNumber: data.patient.phoneNumber ? data.patient.phoneNumber : "",
          phoneNumber2: data.patient.phoneNumber2
            ? data.patient.phoneNumber2
            : "",
          email: data.patient.email,
          bloodType: data.patient.bloodType ? data.patient.bloodType : "",
          ocupacion: data.patient.ocupacion ? data.patient.ocupacion.id : "",
          address: data.patient.address ? data.patient.address : "",
          externalId: data.patient.externalId ? data.patient.externalId : "",
          peso: "",
          talla: "",
          sintomas: "",
          dayAppointment: "",
          doctorId: "",
          hourDayId: "",
          hourDayHour: "",
          doctorName: "",
          especialidadName: "",
          especialidadId: "",
          account: data.patient.account,
          currentInsurance: data.patient.currentInsurance,
          aceptarTerminos: true,
          linkPatient: data.id,
          location: data.patient.localidad ? data.patient.localidad.id : "",
          neighborhood: data.patient.neighborhood
            ? data.patient.neighborhood
            : "",
          identityDocumentType: data.patient.identityDocumentType
            ? data.patient.identityDocumentType.id
            : "",
          identityDocumentTypeModel: data.patient.identityDocumentType
            ? data.patient.identityDocumentType
            : "",
          documentNumber: data.patient.documentNumber
            ? data.patient.documentNumber
            : "",
          country: data.patient.country ? data.patient.country.id : "",
          municipio: data.patient.municipio ? data.patient.municipio.id : null,
          state: data.patient.state ? data.patient.state.id : null,
          expediente: data.expediente ? data.expediente : "",
          patientRelationship: data.patient.patientRelationship
            ? data.patient.patientRelationship.id
            : "",
          hourInit: "",
          colombusAddress: colombusA,
          countryBirth: data.patient.countryBirth
            ? data.patient.countryBirth.id
            : "",
          eps: epsObj,
        };

        if (data.source) {
          //console.log('entro')
          setSource(convertSource(data.source));
          if (data.source !== 8) setNotEdit(true);
        }
        setIsPendienteAprobacion(
          entity.account ? !entity.account.automaticValidation : false
        );
        validateLink(
          data.active,
          data.currentServerTime,
          data.duration,
          data.serverTime
        );
        setInitialData(entity);
        setPhoneNumber(entity.phoneNumber);
        setPhoneNumber2(entity.phoneNumber2 ? entity.phoneNumber2 : "57");
        setTipoSangre(entity.bloodType);
        if (data.patient?.company?.id === 2) {
          setCompanyType("colombia");
        }
        if (data.patient.language) {
          i18n.changeLanguage(data.patient.language.code);
        }
        setLoading(false);
      })
      .catch((error) => {
        //console.log(error)
        setValidLink(false);
        setLoading(false);
      });
  }, []);

  const handleMessageSocket = (message) => {
    setPaymentStatus(message);
  };

  if (declined) {
    return (
      <Container fluid className="content py-5 h-100vh">
        <DeclinadoLegalWarning
          children={
            <div className="text-center">
              <Button
                type="button"
                variant="secondary"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Iniciar nuevamente
              </Button>
            </div>
          }
        />
      </Container>
    );
  }

  return (
    <>
      {paymentStatus === "currentflow" ? (
        <Container fluid className="content h-100vh py-5">
          {configuration && (
            <AutagendamientoStyles
              extraStyle={{
                colorFont: configuration?.colorFont,
                fontSize: configuration?.fontSize,
              }}
            />
          )}
          {loading ? (
            <LoadingList texto={t("espere_porfavor")} />
          ) : validLink ? (
            <Row>
              {configuration?.urlImage && (
                <Col xs="12" md="12">
                  <div className="d-flex align-items-center justify-content-center mb-1 d-block">
                    <Image
                      src={configuration.urlImage}
                      className="doctor-foto-img"
                      style={{ maxHeight: "120px", maxWidth: "120px" }}
                    />
                  </div>
                </Col>
              )}
              {!reservadoExitosamente && (
                <Col className="mb-3" xs="12" md={{ span: 4, offset: 4 }}>
                  <Card>
                    <Card.Body>
                      <div className="d-flex justify-content-between">
                        <div>{t("tiempo_validez")}</div>
                        <div>
                          <CountdownComponentSimple
                            date={startMeeting.toDate()}
                            serverTime={currentTime}
                            setServerTime={setCurrentTime}
                            clientTime={clientTime}
                            setClientTime={setClientTime}
                            onComplete={onComplete}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              )}

              <Col xs="12" md="12">
                {steps[currentStep]}
              </Col>
            </Row>
          ) : (
            <Row>
              <Col xs="12" md={{ span: 4, offset: 4 }}>
                <Card>
                  <Card.Body>
                    <div className="text-center">
                      <p>
                        Esta liga ya se ha usado, no es posible usarla para
                        concluir tu solicitud. Gracias.
                      </p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          <ComponentModalErrorSever
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
          />
        </Container>
      ) : (
        <Container fluid className="content py-5 main">
          <Row className="mb-4">
            <Col xs="12" md={{ span: 6, offset: 3 }} className="text-center">
              {paymentStatus === "DECLINED" ? (
                <div>
                  <p>
                    Sr(a). Usuario: Su cita no pudo ser agendada. El tiempo para
                    realizar el pago de la cita se ha agotado o su pago no fue
                    aprobado, en caso de necesitar el agendamiento de la cita
                    por favor realice de nuevo el proceso. Gracias
                  </p>
                  <Button
                    type="button"
                    variant="secondary"
                    onClick={() => window.location.reload()}
                  >
                    Iniciar proceso
                  </Button>
                </div>
              ) : paymentStatus === "PENDING" ? (
                <p>
                  Sr(a). Usuario: Su cita está en proceso de pago. Recuerde que
                  tiene 15 minutos para realizar el pago, de lo contrario, su
                  cita no será agenda y deberá repetir el proceso de
                  agendamiento. Gracias
                </p>
              ) : (
                paymentStatus === "PAID" && (
                  <div>
                    <p>
                      Sr (a). Usuario: su cita fue pagada con éxito, su servicio
                      se encuentra en proceso de aprobación. Recibirá la
                      confirmación en la brevedad posible mediante mensaje de
                      texto y correo electrónico (verifique la bandeja de correo
                      no deseado) Para cancelar su cita comuníquese con
                      nosotros.
                    </p>
                    <Button
                      type="button"
                      variant="secondary"
                      onClick={() => {
                        //window.open("about:blank", "_self");
                        //window.close();
                        window.location.reload();
                      }}
                    >
                      Finalizar
                    </Button>
                  </div>
                )
              )}
            </Col>
          </Row>
        </Container>
      )}
      {payment && (
        <SockJsClient
          url={`${BASE_URL_WS}/ws`}
          topics={[`/user/${payment.id}/queue/paymentStatus`]}
          onMessage={(message) => handleMessageSocket(message)}
        />
      )}
    </>
  );
}

export default withTranslation()(Autoagendamiento);
